import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RxReload } from 'react-icons/rx';
import ExportIcon from '../../../components/Images/icons/Export_Icon_01.png';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import AdminDeleteModal from '../../../components/CommonComponents/AdminDeleteModal';
import { toast } from 'react-toastify';
import AdminNavbar from '../../../components/CommonComponents/AdminNavbar';
import { BiRecycle } from 'react-icons/bi';
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from '../../../components/CommonMethod/CommonMethods';
import AdminTable from '../../../components/CommonComponents/AdminTable';
import AdminTooltip from '../../../components/CommonComponents/AdminTooltip';
import { Link } from 'react-router-dom';
import MessageBox from '../../../components/CommonComponents/MessageBox';
import { MdRemoveRedEye } from 'react-icons/md';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { FaEllipsisVertical } from 'react-icons/fa6';
import { statusActiveFormatteruser } from '../../../components/CommonMethod/CommonBoostrapFormatter';

const AdvertiserList = (props) => {
   const BaseUrl = process.env.REACT_APP_Baseurl
   const listApi = `${BaseUrl}/admin/advertiser`;
   const multiDelete = `${BaseUrl}/admin/advertiser-delete`
   const { fetchRequest } = useMyContext();
   const [page, setPage] = useState(1)
   const [limit, setLimit] = useState(10);
   const [draft, setDraft] = useState(0);
   const [deleteActionType, setDeleteActionType] = useState(2);
   const [Permanent, setPermanent] = useState(0);
   const [type, setType] = useState(null)
   const [apiData, setApiData] = useState([]);
   const [loading, setLoading] = useState(true);
   const [total, setTotal] = useState('')
   const [itemToDelete, setItemToDelete] = useState([]);
   const [modelClose, setModelClose] = useState(false);
   const [showOverlay, setShowOverlay] = useState(false);
   const [withOutRefresh, setWithoutRefresh] = useState(false)
   const [showModal, setShowModal] = useState(false);
   const [activeId, setActiveId] = useState(null)

   const [formData, setFormData] = useState({
      state: "formData",
      view_type: "list",
      view_type_option: [{
         name: "List",
         value: "list"
      },
      {
         name: "Gallery",
         value: "grid"
      }]
   });

   const singleDelete = (id) => {
      setModelClose(true);
      setItemToDelete([id]);
   };

   const fetchData = async () => {
      setLoading(true)
      await fetchRequest({
         method: 'GET',
         url: `${listApi}`,
         params: { type, page, limit, search: formData?.title },
         data: {},
      })
         .then(response => {
            const result = response;
            const updatedList = result?.data?.map((item) => {
               const UploadStatus = item?.uploaded_by_role;
               const statusText = item?.status === 1 ? "Active" : item?.status === 0 ? "Pending" : "In-Active";
               return {
                  ...item, role: UploadStatus, active: statusText
               };
            });
            setApiData(updatedList);
            console.log("APIDATA", apiData);
            setPage(result?.pagination?.currentPage);
            setTotal(result?.pagination);
            setLoading(false);
         })
         .catch(error => {
            setLoading(false);
         })
   };

   const fetchAllData = async (type, find) => {
      const data = await fetchRequest({
         method: 'GET',
         url: `${listApi}`,
         params: {
            search: find === "ALL" ? null : formData?.title,
            type: null,
            page: 1,
            limit: find === "ALL" ? total?.count_all : total?.totalItems,
         },
         data: {},
      });

      let updatedList;

      if (find === "ALL") {
         updatedList = data?.data || [];
      } else {
         if (!itemToDelete || itemToDelete.length === 0) {
            alert("Please select at least one row to export.");
            return;
         }
         updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
         if (!updatedList || updatedList.length === 0) {
            alert("Selected data not found.");
            return;
         }
      }

      const exportData = updatedList.map((item, index) => ({
         "S.NO": index + 1,
         "ID": item?.id,
         "ADVERTISER NAME": item?.company_name,
         "E-MAIL": item?.email_id,
         "MOBILE": item?.ccode + item?.mobile_number,
         "STATUS": item?.status === 1 ? "APPROVED" : "REJECTED"
      }));

      if (type === "CSV") {
         await donwloadCSV(exportData, "ADVERTISER-LIST");
      } else if (type === "PDF") {
         await videodownloadPDF(exportData, "ADVERTISER-LIST", [
            "S.NO", "ID", "ADVERTISER NAME", "E-MAIL", "MOBILE", "STATUS"
         ]);
      } else if (type === "XLSX") {
         await videodownloadXLSX(exportData, "ADVERTISER-LIST", [
            "S.NO", "ID", "ADVERTISER NAME", "E-MAIL", "MOBILE", "STATUS"
         ]);
      }
   };

   useEffect(() => {
      fetchData();
   }, [page, limit, formData?.title, withOutRefresh, draft]);

   const handleConfirmDelete = async () => {
      setShowOverlay(true);
      await fetchRequest({
         method: 'DELETE',
         url: `${multiDelete}/${itemToDelete}`,
         params: {},
         data: {},
      })
         .then(response => {
            const result = response;
            if (result?.status) {
               toast.success(result?.message);
               setItemToDelete([])
            }
         })
         .catch(error => {
            toast.error(error?.response?.data?.message || error?.message)
         }).finally(() => {
            setShowOverlay(false)
            setWithoutRefresh(!withOutRefresh);
         })
   };

   const handleActionData = () => {
    handleStatusChange(selectedId, selectedStatus === "Approve" ? 1 : 2);
    closeModal();
  };

   const handleStatusChange = async (id, status) => {
      setLoading(true)
      try {
         const response = await fetchRequest({method: 'PATCH', url: `${process.env.REACT_APP_Baseurl}/admin/advertiser-update-status/${id}`, data: { id, status }})
         if(response?.status){
            toast.success(response?.message)
             const statusText = status === 1 ? "Active" : status === 0 ? "Pending" : "In-Active";
            setApiData(prev => 
               prev.map(item =>
                  item.id === id ? {...item, active: statusText, status: status} : item
                )
            )
         }
      } catch (error) {
         console.error(error.response.message)         
      } finally {
         setLoading(false)
      }
      
   };

   const [selectedId, setSelectedId] = useState(null);
   const [selectedStatus, setSelectedStatus] = useState(null);

   const handleButtonClick = (id, status) => {
      setSelectedId(id);
      setSelectedStatus(status === 1 ? "Approve" : "Reject");
      setShowModal(true);
      setModelClose(true);
   };
   const columns = [
      {
         dataField: "company_name",
         text: "Advertiser Name",
         sort: true,
         className: "userDesignBox",
         formatter: (cell, row) => {
            const shortName = cell?.length > 15 ? `${cell.slice(0, 15)}...` : cell;
            return (
               <div className="d-flex justify-content-between align-items-center">
                  <span className="text-break" title={cell}>{shortName}</span>
                  <span className="text-muted">{row?.upload_on}</span>
               </div>
            );
         }
      },
      {
         dataField: "email_id",
         text: "Email ID",
         sort: true,
         formatter: (cell, row) => (
            <div className="d-flex justify-content-between align-items-center">
               <span className="text-break">{cell}</span>
            </div>
         ),
         className: "userDesignBox",
      },
      {
         dataField: "mobile_number",
         text: "Mobile Number",
         sort: true,
         formatter: (cell, row) => (
            <div className="d-flex align-items-center gap-1">
               {cell != null && cell != undefined ? (
                  <>
                     <span className="text-break">{row?.ccode}</span>
                     <span className="text-break">{cell}</span>
                  </>) :
                  (<>
                     <span className='text-break ms-5'> - </span>
                  </>)}
            </div>
         ),
      },
      {
         dataField: "active",
         text: "Status",
         sort: true,
         formatter: (cell, row) => statusActiveFormatteruser(cell, row),
      },
      {
         dataField: "status",
         text: "Actions",
         formatter: (cell, row) => <div className="editdropdown"
            onClick={() => setActiveId(row.id)}
            onMouseLeave={() => setActiveId(null)}
            id={`moreOption`}>
            <span className="editdropdown-button">
               <FaEllipsisVertical />
            </span>
            <div className={`editdropdown-menu theme-bg-color ${activeId == row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
               <Link id={`View `} to={`${"/editadvertiser/"}${row?.id}`} className="theme-text-color theme-bg-color">
                  <span className="theme-text-color">
                     <MdRemoveRedEye style={{ width: "20px", height: "20px" }} />
                     <MessageBox text="View Details" classname='ms-2 theme-text-color'></MessageBox>
                  </span>
               </Link>
               {cell !== 1 &&
                  <>
                     <div id={`approveButton`} onClick={() => handleButtonClick(row.id, 1)} className="commonActionPadding theme-bg-color">
                        <FaCheck style={{ width: "16px", height: "16px", color: "#28a745" }} />
                        <MessageBox text="Approve" classname='ms-2 theme-text-color'></MessageBox>
                     </div>
                     {cell === 2 ? 
                     <div id={`rejectButton`} className="commonActionPadding theme-bg-color">
                        <FaTimes style={{ width: "16px", height: "16px", color: "#dc3545" }} />
                        <MessageBox text="Already Rejected" classname='ms-2 theme-text-color'></MessageBox>
                     </div>
                    :
                     <div id={`rejectButton`} onClick={() => handleButtonClick(row.id, 2)} className="commonActionPadding theme-bg-color">
                        <FaTimes style={{ width: "16px", height: "16px", color: "#dc3545" }} />
                        <MessageBox text="Reject" classname='ms-2 theme-text-color'></MessageBox>
                     </div>
                      }
                  </>
               }
            </div>
         </div>
      },
   ];

   const options = {
      pageStartIndex: 1,
      paginationSize: 3,
      sizePerPage: 10,
      sizePerPageList: [
         { text: '5', value: 5, id: "optionOne" },
         { text: '10', value: 10, id: "optionTwo" },
         { text: 'All', value: total?.totalItems, id: "optionThree" }
      ]
   };

   const handlePageChange = (page) => {
      setPage(page);
   };


   const reloadAction = () => {
      setDraft(0)
      setWithoutRefresh(prev => !prev)
      setApiData([])
   }

   const reCycleBin = () => {
      setDraft(prev => prev === 1 ? 0 : 1);
   };

   const handleInput = (e) => {
      const { type, name, value, checked } = e.target
      if (type === "search") {
         setFormData((prev) => ({
            ...prev,
            [name]: value,
         }))
      }
      if (type === 'select-one') {
         setFormData((prev) => ({
            ...prev,
            [name]: value,
         }));
      }
   }

   const handleSizePerPageChange = (e) => {
      setLimit(Number(e.target.value));
      setPage(1);
   };

   const selectRow = {
      selected: itemToDelete,
   };

   const handleSort = (field) => {
      const sortedData = [...apiData].sort((a, b) => {
         if (a[field] < b[field]) return -1;
         if (a[field] > b[field]) return 1;
         return 0;
      });
      setApiData(sortedData);
   };

   const handleRowSelect = (rowId) => {
      if (itemToDelete.includes(rowId)) {
         setItemToDelete(itemToDelete.filter((id) => id !== rowId));
      } else {
         setItemToDelete([...itemToDelete, rowId]);
      }
   };

   const handleSelectAll = () => {
      if (itemToDelete.length === apiData.length) {
         setItemToDelete([]);
      } else {
         setItemToDelete(apiData.map((row) => row.id));
      }
   };

   const openModal = () => {
      setModelClose(true);
   };

   const closeModal = () => {
      setModelClose(!closeModal);
      setShowModal(false);
      setItemToDelete([])
   };


   const handleDeletedata = () => {
      handleConfirmDelete();
      closeModal();
   };

   return (
      <>
         <AdminNavbar heading={"All Advertisers"} totalDataLength={total?.totalItems} deleteCount={itemToDelete?.length} deleteMethod={openModal} />
         
         {showModal && 
                 <AdminDeleteModal 
                   headingText={selectedStatus === "Approve" ? "Confirm Approval" : "Confirm Rejection"} 
                   message={selectedStatus === "Approve" ? "Are you sure you want to approve these Advertiser(s)?" : "Are you sure you want to reject these Advertiser(s)?"}
                   modelClose={modelClose} 
                   deleteClose={closeModal} 
                   deleteAction={handleActionData} 
                   buttonText={"custom"} 
                   actionText={selectedStatus === "Approve" ? "Approve" : "Reject"}
                   buttonBg={selectedStatus === "Approve" ? "danger" : "success"}
                 />
               }

         <div className='theme-bg-color p-3 rounded-3 mb-5'>
            <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
               <input type='search' placeholder='Search' name="title" className='rounded-3  theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} id='searchInput' />
               <div className=' d-flex align-items-center'>
                  <button className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} onClick={reloadAction} id='reloadButton'>
                     <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                     <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                  </button>
                  <div className="dropdown d-block ms-2 " key={"2"}>
                     <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                        <span className="fw-bolder text-white">Export</span>
                        <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                     </button>
                     <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                        <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => fetchAllData("CSV")}>CSV</li>
                        <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => fetchAllData("PDF")}>PDF</li>
                        <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => fetchAllData("XLSX")}>XLSX </li>
                     </ul>
                  </div>
                  <div className="dropdown d-block ms-2 " key={"2"}>
                     <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                        <span className="fw-bolder text-white">Export all</span>
                        <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                     </button>
                     <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                        <li className="dropdown-item theme-text-color" id='exportAllCSV' onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                        <li className="dropdown-item theme-text-color" id='exportAllPDF' onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                        <li className="dropdown-item theme-text-color" id='exportAllXLSX' onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
                     </ul>
                  </div>
               </div>
            </div>

            <AdminTable data={apiData}
               loading={loading}
               options={options}
               handlePageChange={handlePageChange}
               page={page}
               pagination={total}
               handleSizePerPageChange={handleSizePerPageChange}
               columns={columns}
               limit={limit}
               selectRow={selectRow}
               multiSelect
               onRowSelect={handleRowSelect}
               onSort={handleSort}
               onSelectAll={handleSelectAll}
               viewType={formData?.view_type}
            />
         </div>
      </>
   );
};

export default AdvertiserList;